export const Constants  = {
    HOUR_IN_SECS : 60 * 60,
    MINUTE_IN_SECS : 60
} 
export default Constants